<template>
  <footer class="component-footer">
      <div class="wrapper">
          <!-- col-12 col-md-6 left -->
          <!-- <dl class="">
              <dt>加入我们</dt>
              <dd>简历投递：HR@milinzone.com</dd>
          </dl> -->
          <!-- col-12 col-md-6 left mt-2 mt-sm-0 -->
          <dl class="">
              <dt>联系我们</dt>
              <!-- <div class="mini_relation" @click="goRelationPage">
                <div class="relation_info">观看视频</div>
                <div class="relation_icon"></div>
              </div> -->
              <openWeapp></openWeapp>
              <dd>客服电话：010-57347630</dd>
              <dd>微信公众号：秘邻圈</dd>
          </dl>
      </div>
      <div class="info">
          <p>量子像素（北京）科技有限公司 <a href="https://beian.miit.gov.cn/">京ICP备19037457号</a></p>
      </div>
  </footer>
</template>
<script>
import util from "../util/util.js";
import openWeapp from "./openWeapp"
export default {
    components: {
        openWeapp
    },
    methods: {
        goRelationPage(){
            util.goContact();
        }
    }
}
</script>

<style lang="scss" scoped>
    .component-footer {
        padding-top: 100px;
        background: #fff;
        text-align: center;

        @media screen and(min-width: 768px) {
            & {
                padding-top: 50px;
                .wrapper {
                    width: 100%;
                    max-width: 1100px;
                    margin: 0 auto;
                    display: flex;
                    justify-content: space-around;
                }
            }
            
        }

        // .wrapper {
        //     width: 100%;
        //     max-width: 1100px;
        //     margin: 0 auto;
        //     display: flex;
        //     justify-content: space-around;
        // }

        dl {

            text-align: left;
            .mini_relation{
                width: 136px;
                height: 44px;
                border-radius: 7px;
                border: 1px solid #07C160;
                // position: absolute;
                // right: 0px;
                // bottom: -115px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                box-shadow: 0px 1px 18px 0px rgba(7, 193, 96, 0.19);
                margin-bottom: 10px;
            }
            .relation_info{
                font-size: 18px;
                margin-right: 10px;
                line-height: 44px;
                font-weight: 500;
            }
            .relation_icon{
                width: 18px;
                height: 18px;
                background: url("../assets/jump_icon.png") center center;
                background-size: 100% 100%;
            }
        }

        dt {
            font-size: 18px;
            margin-bottom: 10px;
        }

        dd {
            font-size: 14px;
            color: #666;
            line-height: 2;
        }

        .info {
            padding: 15px 0;
            line-height: 30px;
            background: #eee;
            font-size: 12px;

            p {
                margin: 0
            }
        }

        
        // @media screen and(min-width: 769px) {
            // .left {
            //     padding-left: 20%;
            // }
        // }
    }
@media screen and(max-width: 768px) {
      .wrapper {
            width: 100%;
            padding: 0px 20px;
            box-sizing: border-box;
        }
  }

</style>
